import script from "./CombinePositioner.vue?vue&type=script&setup=true&lang=js"
export * from "./CombinePositioner.vue?vue&type=script&setup=true&lang=js"

import "./CombinePositioner.vue?vue&type=style&index=0&id=9a183700&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a183700"]])

export default __exports__